import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const QuickSearchSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="currentColor">
        <path d="M5 13.5a7.5 7.5 0 0 1 6-7.35v1.02A6.5 6.5 0 1 0 18.98 13h1l.02.5a7.47 7.47 0 0 1-1.85 4.94L23 23.29l-.71.7-4.85-4.84A7.5 7.5 0 0 1 5 13.5"></path>
        <path d="M17 4v4h2a1 1 0 0 1 .83 1.55l-4 6A1 1 0 0 1 14 15v-4h-2a1 1 0 0 1-.83-1.55l4-6A1 1 0 0 1 17 4m-2 11 4-6h-3V4l-4 6h3z"></path>
    </svg>
)

const QuickSearchIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {QuickSearchSvg}
    </SvgIcon>
)

export default QuickSearchIcon